import { ResponsiveContainer, XAxis, YAxis, Tooltip, LabelList, ScatterChart, Scatter, Label, ZAxis, ReferenceLine } from "recharts";
import { numberFormatter } from "../../utils";

const ScatterGraph = (props: any) => {
    const data = props.data;
    const view = props.view;
    const ref = props.threshold;
    const selected = props.clickedBubble;
    console.log(view);

    const handleScatterClick = (data: any) => {
        if (data.name == selected) {
            props.handleClick(null);
        } else {
            props.handleClick(data.name);
        }
    }

    const customTooltip = ({ active, payload }: any) => {
        if (active && payload && payload.length) {
            const data = payload[0].payload;
            return (
                <div className="custom-tooltip">
                    <p className="label" style={{ padding: "0", margin: "0" }}>
                        <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal", textTransform: 'capitalize' }}>{view}: </label>
                        <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                            {data.name}</label></p>
                    <p className="label" style={{ padding: "0", margin: "0" }}>
                        <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>Gross Margin: </label>
                        <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                            {data.grossMargin}%</label></p>
                    <p className="label" style={{ padding: "0", margin: "0" }}>
                        <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>5-Year CAGR: </label>
                        <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                            {numberFormatter(data.cagr, 0)}%</label></p>
                    <p className="label" style={{ padding: "0", margin: "0" }}>
                        <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>Spend: </label>
                        <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                            {numberFormatter(data.spend, 0, '$')}</label></p>
                </div>
            )
        }
    }

    const renderCustomizedLabel = (props: any, d: any) => {
        const { x, y, width, value, name } = props;
        return (
            <text x={x + width / 2} y={y - 10} fill='#fff' fontSize={10} textAnchor="middle" dominantBaseline="middle" >
                {d.length > 10 && view != 'l1' ? d.slice(0, 10) + '...' : d}
            </text>
        );
    };

    return (
        <ResponsiveContainer width="100%" height="100%">
            <ScatterChart
                margin={{
                    top: 20,
                    right: 40,
                    bottom: 20,
                    left: 10,
                }}
            >
                <XAxis
                    type="number"
                    dataKey="cagr"
                    stroke="white"
                    unit="%"
                    // domain={[(dataMin: number) => Math.floor(dataMin / 10) * 10, (dataMax: number) => Math.ceil(dataMax > 100 ? dataMax / 20 : dataMax / 10) * (dataMax > 100 ? 20 : 10)]}
                    domain={([dataMin, dataMax]) => {
                        const divFactor = dataMax > 100 ? 20 : 10;
                        return [Math.floor(dataMin / divFactor) * divFactor, Math.ceil(dataMax / divFactor) * (divFactor)];
                    }}
                // interval="equidistantPreserveStart"
                >
                    <Label value="5-year CAGR" offset={0} position="bottom" style={{ fill: 'white' }} />
                </XAxis>
                <YAxis stroke="white" dataKey="grossMargin" unit="%" domain={([dataMin, dataMax]) => {
                    const divFactor = dataMax > 100 ? 20 : 10;
                    return [Math.floor(dataMin / divFactor) * divFactor, Math.ceil(dataMax / divFactor) * (divFactor)];
                }}>
                    <Label value="Gross Margin (%)" angle={-90} position="insideLeft" style={{ fill: 'white' }} />
                </YAxis>
                <ZAxis type="number" dataKey="spend" range={[50, 500]}></ZAxis>
                <ReferenceLine x={ref.x} label={{ position: 'top', fill: '#ce9178', value: numberFormatter(ref.x, 0) + '%', fontStyle: 'italic' }} stroke="white" strokeDasharray="5 3" opacity={0.3} />
                <ReferenceLine y={ref.y} label={{ position: 'right', fill: '#ce9178', value: numberFormatter(ref.y, 0) + '%', fontStyle: 'italic' }} stroke="white" strokeDasharray="5 3" opacity={0.3} />
                <Tooltip contentStyle={{ color: "white", backgroundColor: "rgb(26, 25, 22)" }} cursor={{ strokeDasharray: "3 3" }} content={customTooltip} />
                {data.map((d: any, index: number) => {
                    if (Math.abs(d.cagr) <= 50) {
                        if (d.cagr >= ref.x && d.grossMargin >= ref.y) {
                            return <Scatter key={index} data={[d]} fill="#008b00" onClick={handleScatterClick} opacity={selected == null ? 1 : (selected == d.name) ? 1 : 0.1}>
                                {data.length <= 15 && view == 'l1' && <LabelList dataKey={d.name} content={(ele: any) => renderCustomizedLabel(ele, d.name)} />}
                            </Scatter>
                        } else if (d.cagr <= ref.x && d.grossMargin >= ref.y) {
                            return <Scatter key={index} data={[d]} fill="#c79c38" onClick={handleScatterClick} opacity={selected == null ? 1 : (selected == d.name) ? 1 : 0.1}>
                                {data.length <= 15 && view == 'l1' && <LabelList dataKey={d.name} content={(ele: any) => renderCustomizedLabel(ele, d.name)} />}
                            </Scatter>
                        } else if (d.cagr <= ref.x && d.grossMargin <= ref.y) {
                            return <Scatter key={index} data={[d]} fill="#d55454" onClick={handleScatterClick} opacity={selected == null ? 1 : (selected == d.name) ? 1 : 0.1}>
                                {data.length <= 15 && view == 'l1' && <LabelList dataKey={d.name} content={(ele: any) => renderCustomizedLabel(ele, d.name)} />}
                            </Scatter>
                        } else {
                            return <Scatter key={index} data={[d]} fill="#60b5bf" onClick={handleScatterClick} opacity={selected == null ? 1 : (selected == d.name) ? 1 : 0.1}>
                                {data.length <= 15 && view == 'l1' && <LabelList dataKey={d.name} content={(ele: any) => renderCustomizedLabel(ele, d.name)} />}
                            </Scatter>
                        }
                        // return <Scatter key={index} data={[d]} fill="#8884d8" onClick={handleScatterClick} opacity={selected == null ? 1 : (selected == d.name) ? 1 : 0.3} />
                    }
                })}

            </ScatterChart>
        </ResponsiveContainer >
    )
}

export default ScatterGraph;